import React from 'react'
import { Location } from '../../domain/models/Location'

export interface Position {
  lat: number
  lng: number
}

export interface IMapManagerContext {
  panTo: (prop: Location | null) => void
  panToLocation: Location | null
  zoom: number
  setZoom: React.Dispatch<React.SetStateAction<number>>
  position: Position
  recordPosition: (pos: Position) => void
}

export const MapContext = React.createContext<IMapManagerContext>({
  panTo: () => console.warn('panTo not implemented'),
  panToLocation: null,
  zoom: 17,
  setZoom: () => console.warn('setZoom not implemented'),
  position: { lat: 55.296249, lng: 25.276987 },
  recordPosition: () => console.warn('recordPosition not implemented')
})

export const useMapContext = (): IMapManagerContext => React.useContext(MapContext)
